export default __webpack_public_path__ + "static/media/petroamazonas-logo.80478bde.png";